import Drafts from './Drafts';
import DraftsContainer from './Drafts.container';

export default DraftsContainer(Drafts);
